import React from "react";
import { Button } from "primereact/button";
import MobileBottomSheet from "presentation/mobile/components/MobileBottomSheet";
import MobileAlertBanner from "presentation/mobile/components/MobileAlertBanner";

interface SubmitTimesheetModalProps {
    visible: boolean;
    onHide: () => void;
    periodLabel: string;
    onConfirm: () => Promise<void>;
    isSubmitting: boolean;
}

const SubmitTimesheetModal: React.FC<SubmitTimesheetModalProps> = ({
    visible,
    onHide,
    periodLabel,
    onConfirm,
    isSubmitting,
}) => {
    return (
        <MobileBottomSheet
            visible={visible}
            onHide={onHide}
            title="Submeter Mapa de Horas"
            headerIcon="pi pi-send"
            footer={
                <div className="w-full flex gap-2">
                    <Button
                        label="Cancelar"
                        className="btn-mobile-secondary flex-1"
                        type="button"
                        onClick={onHide}
                        disabled={isSubmitting}
                    />
                    <Button
                        label={isSubmitting ? "A submeter..." : "Confirmar Envio"}
                        icon={isSubmitting ? "pi pi-spin pi-spinner" : "pi pi-check"}
                        className="btn-mobile flex-1"
                        type="button"
                        onClick={onConfirm}
                        disabled={isSubmitting}
                    />
                </div>
            }
        >
            <div className="flex flex-column gap-3 py-1">
                {/* Resumo do Período e Estado */}
                <div className="card-mobile p-3" style={{ backgroundColor: "#F8FAFC" }}>
                    <div className="flex justify-content-between align-items-center mb-2">
                        <span className="text-sm font-semibold text-900">Período</span>
                        <span
                            className="badge-squircle"
                            style={{
                                color: "#0084D1",
                                backgroundColor: "#EFF6FF",
                                border: "1px solid #BFDBFE",
                            }}
                        >
                            {periodLabel}
                        </span>
                    </div>
                    <div className="flex justify-content-between align-items-center">
                        <span className="text-xs text-500">Novo Estado</span>
                        <span
                            className="badge-squircle"
                            style={{
                                color: "#D97706",
                                backgroundColor: "#FFFBEB",
                                border: "1px solid #FDE68A",
                            }}
                        >
                            Enviado
                        </span>
                    </div>
                </div>

                {/* Banner de Aviso Informativo */}
                <MobileAlertBanner severity="info">
                    Ao submeter, será gerado o comprovativo em PDF e o mapa será bloqueado. Não poderá fazer novas alterações após o envio.
                </MobileAlertBanner>
            </div>
        </MobileBottomSheet>
    );
};

export default SubmitTimesheetModal;